import React from "react";
import { SectionDefinition } from "api/factories/form.factory";
import {
    HtmlReadOnly,
    ReadOnlyField,
    TextField,
    DatePicker,
    DateTimePicker,
    NumberField,
    TextFieldArray,
} from "components/SchemaProvider";
import { useSchemaProviderContext } from "hooks";

export type SectionDefinitionValue = string | Array<{ [key: string]: string | number }>;

export const FieldSelector = (props: SectionDefinition<SectionDefinitionValue>) => {
    const { isEdit } = useSchemaProviderContext();

    if (!props.editable || (!isEdit && props.editable)) {
        return (
            <ReadOnlyField
                dateTime={props.type === "DateTime"}
                date={props.type === "Date"}
                caption={props.translation}
                label={props.value}
                tooltip={props.tooltip}
                colour={props.colour}
            />
        );
    }

    if (!Array.isArray(props.value)) {
        switch (props.type) {
            case "String": {
                return <TextField {...props} />;
            }

            case "Number": {
                return <NumberField {...props} />;
            }

            case "Date": {
                const { value, ...dateProps } = props;

                return <DatePicker value={value} {...dateProps} />;
            }

            case "DateTime": {
                const { value, ...dateTimeProps } = props;

                return <DateTimePicker value={value} {...dateTimeProps} />;
            }

            case "Html": {
                return <HtmlReadOnly html={props.value} />;
            }

            default: {
                return <ReadOnlyField caption={props.translation} label={`Field "${props.type}" is unhandled`} />;
            }
        }
    }

    // we assume that this is text field with object of
    return <TextFieldArray {...props} />;
};
